
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyDefault as ObiSimplifiedBuoyDefaultElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-default.js';
 
 
 

 
 export const ObiSimplifiedBuoyDefault = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-default',
   elementClass: ObiSimplifiedBuoyDefaultElement,
   events: {
     
   }
  });
 
 